<template>
  <DBox
    :id="'cmp-catalog-releases-sidewindow-artist'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="$t('add_new_artist')"
    @add_click="onAddArtist"
  >
    <!-- :expandable="true" -->
    <NTable
      class="dbox1"
      id="catalog-releases-artist"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('ds_artist')">
            <span @click="onArtistClicked(item)" class="ut-link ut-text-accent5">{{ item["artist_name"] }}</span>
          </td>
          <td v-bind="tdcon('artist_rank')">
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              :disabled="false"
              :options="artistRanksTV"
              :selected="artistRanksTV.find(v => v.value == item.relation_rank)"
              :placeholder="$t('artist_rank')"
              v-on:selectedChange="e => onDropdownChange(item, e)"
              :bb="'0px'"
            />
          </td>
          <td v-bind="tdcon('artist_role')">
            <TextField2
              type="text"
              class="dbox1"
              id="role"
              :showLabel="false"
              :disabled="false"
              :value="item['role']"
              :bb="'0px'"
              @change="e => onTextFieldChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('option')">
            <div class="dt-icon-container">
              <img
                @click.stop="e => deleteArtist(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { tv } from "../../../../models/text-value.model";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { catalogArtistListLDTRoutes } from '../../router/routes';
export default {
  props: {
    selectedReleaseDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("ds_artist", {}),
        createTableHeader("artist_rank", {}),
        createTableHeader("artist_role", {}),
        createTableHeader("option", { text: false, mw: 30 })
      ];
    },

    list: function() {
      return this.selectedReleaseDetails.artists || [];
    },

    artistRanksTV: function() {
      return this.selectedReleaseDetails.artist_ranks.map(tv("text", "value"));
    }
  },
  methods: {
    onTextFieldChange: function(e, item) {
      const payload = {
        name: e.name,
        value: e.value,
        item: item
      };
      this.$emit("change", payload);

      console.log("ARTIST", payload, e);
    },
    onDropdownChange: function(item, e) {
      const payload = {
        name: "relation_rank",
        value: e.value,
        item: item
      };
      this.$emit("change", payload);
    },

    onAddArtist: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_artist",
          external_id: this.selectedReleaseDetails.release.release_id
        }
      });
    },
    deleteArtist: async function(item) {
      const confirmationResult = await confirmDelete(
        "Artist",
        item.artist_name
      );
      if (confirmationResult == "OK") {
        const payload = { relation_id: item.relation_id };
        this.$emit("delete", payload);
      }
    },

    onArtistClicked:function(item){
      console.log(item)

      this.$router.push({
        name: catalogArtistListLDTRoutes.names.tab,
        params: {
          label_artist_id: item.label_artist_id,
          tab: "overview"
        }
      });

    }
  }
};
</script>
